<router-outlet />
<shared-loader loader="primary"></shared-loader>